import axios, { AxiosError } from "axios";
import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";

const { Bearer } = AUTHORIZATION;
const { post } = request;
const initialRoute = "group/member";

type ChangePasswordPayload = {
	old_password: string;
	new_password: string;
};

export const changePassword = async (_payload: ChangePasswordPayload): Promise<boolean> => {
	try {
		const endpoint = `${initialRoute}/employee-change-password`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Password has been changed successfully!") {
				return true;
			}
		}
		throw new Error();
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		if (err.response.status === 400 || err.response.status === 500 || err.response.status === 401) {
			const { message } = err.response.data;
			alert(message);
		}
		return false;
	}
};
